/**
 * Application Configuration Constants
 *
 * These constants are used throughout the application for OAuth, API endpoints,
 * localStorage keys, and version management.
 */

export const GOOGLE_CLIENT_ID =
  "738539572204-11l9vctq31biv2gjl3um9r5dan0lp01u.apps.googleusercontent.com";

export const SCOPES = "https://www.googleapis.com/auth/drive.file";

export const APP_VERSION = "4.8.3";

export const LOCAL_STORAGE_KEY = "liftforge_state";

export const APP_BUILD_DATE = "2026-03-22";

// Changed from workers URL to same-origin Pages Function endpoint
export const AI_PROXY_URL = "/api/ai";

export const AI_PROMPT_VERSION = 3;

export const AI_STORAGE_KEY = "liftforge_ai_config";

export const AI_CACHE_KEY = "liftforge_ai_cache";

export const AI_USAGE_KEY = "liftforge_ai_usage";

export const SPREADSHEET_NAME = "Workout Tracker Data";

export const SHEETS_API = "https://sheets.googleapis.com/v4/spreadsheets";

export const DRIVE_API = "https://www.googleapis.com/drive/v3/files";

// Storage migration mapping: old app (workit) to new app (liftforge)
export const LOCAL_STORAGE_MIGRATION_MAP = [
  ["workit_state", "liftforge_state"],
  ["workit_session", "liftforge_session"],
  ["workit_last_synced", "liftforge_last_synced"],
  ["workit_ai_config", "liftforge_ai_config"],
  ["workit_ai_cache", "liftforge_ai_cache"],
  ["workit_ai_usage", "liftforge_ai_usage"],
] as const;

export const SESSION_STORAGE_MIGRATION_MAP = [
  ["workit_token", "liftforge_token"],
  ["workit_coach_enabled", "liftforge_coach_enabled"],
] as const;

// Schema version for data compatibility checks
export const SCHEMA_VERSION = 2;

// Config timestamp key for tracking last update
export const CONFIG_TIMESTAMP_KEY = "liftforge_config_timestamp";
